module.exports = __webpack_public_path__ + "img/commercial_03_brand.0181d289.svg";